import { ECountries } from "src/shared/types/common.types";
import { EOrganizationValue } from "src/shared/types/companies.types";
import { messages } from "./messages";
import * as regexps from "./regexps";

export const getOgrnRules = (type: EOrganizationValue | "") => {
  return {
    required: messages.required,
    validate: (val: string) => {
      switch (type) {
        case EOrganizationValue.LegalEntity: {
          return /^[0-9]{13}$/.test(val) || "13 цифр";
        }

        default: {
          return /^[0-9]{15}$/.test(val) || "15 цифр";
        }
      }
    },
  };
};

export const getCurrentAccountRules = ({
  country_id,
  organization_form,
}: {
  country_id: ECountries | "";
  organization_form: EOrganizationValue | "";
}) => {
  switch (country_id) {
    case ECountries.BY: {
      return {
        required:
          organization_form === EOrganizationValue.LegalEntity
            ? messages.required
            : undefined,
        pattern: {
          value: /^[a-zA-Z0-9]{28}$/,
          message: "28 символов [Aa-Zz 0-9]",
        },
      };
    }
    case ECountries.RU: {
      return {
        required:
          organization_form === EOrganizationValue.LegalEntity
            ? messages.required
            : undefined,
        pattern: {
          value: /^[a-zA-Z0-9]{20}$/,
          message: "20 символов [Aa-Zz 0-9]",
        },
      };
    }
    default: {
      return {
        pattern: {
          value: /^[a-zA-Z0-9]{0,34}$/,
          message: "0 - 34 символов [Aa-Zz 0-9]",
        },
      };
    }
  }
};

export const getOkpoAccountRules = (
  type: EOrganizationValue | "",
  countryId: ECountries | "",
) => {
  return {
    validate: (val: string) => {
      if (countryId === ECountries.BY) {
        if (!val) return true;

        return /^[0-9]{10}$/.test(val) || "ОКПО должен состоять из 10 цифр";
      }
      if (countryId === ECountries.RU) {
        if (!val) return true;

        switch (type) {
          case EOrganizationValue.LegalEntity: {
            return /^[0-9]{8}$/.test(val) || "ОКПО должен состоять из 8 цифр";
          }

          default: {
            return /^[0-9]{10}$/.test(val) || "ОКПО должен состоять из 10 цифр";
          }
        }
      }

      return true;
    },
  };
};

export const getRegistrationNumberRules = (
  type: EOrganizationValue,
  registration_country_id: ECountries | "",
) => {
  return {
    required: messages.required,
    validate: (val: string) => {
      if (!val) return true;
      switch (registration_country_id) {
        case ECountries.BY: {
          switch (type) {
            case EOrganizationValue.Individual: {
              return true;
            }
            default: {
              return /^[0-9]{9}$/.test(val) || "УНП должен состоять из 9 цифр";
            }
          }
        }
        case ECountries.RU: {
          switch (type) {
            case EOrganizationValue.LegalEntity: {
              return (
                /^[0-9]{10}$/.test(val) || "ИНН должен состоять из 10 цифр"
              );
            }
            default: {
              return (
                /^[0-9]{12}$/.test(val) || "ИНН должен состоять из 12 цифр"
              );
            }
          }
        }
        default:
          return (
            /^[A-Za-zА-Яа-яЁё0-9]{1,30}$/.test(val) ||
            "0 - 30 символов [A-Za-zА-Яа-яЁё0-9]"
          );
      }
    },
  };
};
export const postcodeRule = {
  pattern: {
    value: /^\d{6}$/,
    message: messages.postcode,
  },
};

export const bankNameRulePattern = {
  value: regexps.bankNameRegexp,
  message: messages.bankName,
};
